import CXMApiClient from "../../CXMApiClient";
import DeskingApiClient from "@/api/DeskingApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    CanPushToDMS: [],
    dmsPushNotification: null,
    PushToPBSModalInfo: {
      ShowModal: false,
      TradeVehicles: [],
      ReplacementVehicles: [],
      Customer: null,
      IsGarage: false
    },
    PushToDmsModalInfo: {
      ShowModal: false,
      Data: null
    }
  };
}

const state = initialState();

const getters = {
  dmsPushNotification: function(state) {
    return state.dmsPushNotification;
  },
  PushToPBSModalInfo(state) {
    return state.PushToPBSModalInfo;
  },
  CanPushToDMS: function(state) {
    return state.CanPushToDMS;
  },
  PushToDmsModalInfo(state) {
    return state.PushToDmsModalInfo;
  }
};

const actions = {
  setPushToDmsModal(context, val) {
    context.commit("setPushToDmsModal", val);
  },
  clearPushToDmsModal(context) {
    context.commit("clearPushToDmsModal");
  },
  setPushToPBSModal(context, val) {
    context.commit("setPushToPBSModal", val);
  },
  clearPushToPbsModal(context) {
    context.commit("clearPushToPbsModal");
  },
  canPushToDMSOld: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/push_to_dms/is_valid", request, scope)
        .then(resp => {
          if (resp.data && resp.data.successful) {
            let data = resp.data.data;
            data.accountPlatformId = request.accountPlatformId;
            context.commit("updateCanPushToDMSSingle", data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  canPushToDMSMultiStoreOld: async function(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/push_to_dms/is_valid_list",
      request
    );
    if (response.data && response.data.successful) {
      context.commit("updateCanPushToDMS", response.data.data);
    }
  },
  canPushToDMSMultiStore: async function(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/push_to_dms/v2/validate",
      request
    );
    if (response.data && response.data.successful) {
      context.commit("updateCanPushToDMS", response.data.data);
    }
  },

  getDMSErrorMessage: async function(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/push_to_dms/dms_push_result_log",
      request
    );
    if (response.data && response.data.successful) {
      return response.data.data;
    }
  },

  getFinanceErrorMessage: async function(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/push_to_dms/finance_push_result_log",
      request
    );
    if (response.data && response.data.successful) {
      return response.data.data;
    }
  },
  getLatestDMSPushSuccessV2: async function(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/push_to_dms/v2/history/previous",
      request
    );
    return response && response.data && response.data.data
      ? response.data.data
      : null;
  },

  getLatestDMSPushSuccess: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/push_to_dms/get_latest_success",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  pushCustomerToDMS: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/push_to_dms/push_customer",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  pushCustomerToDMSV2: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/v2/push/customer/" + request.id,
      request.request
    );
    if (resp.data && resp.data.successful) return resp.data.data;
    else return resp;
  },
  pushDealToDMSV2: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/v2/push/deal/" + request.id,
      request.request
    );
    if (resp.data && resp.data.successful) return resp.data.data;
    else return resp;
  },
  pushToFAndI: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/push_to_dms/push_to_f_and_i",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp.response);
        });
    });
  },
  pushPBSFullToFAndI: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/pbs/push_to_f_and_i",
      request
    );
    if (resp.data && resp.data.successful) return resp.data.data;
    else return resp;
  },
  clearDmsNotification: function(context) {
    context.commit("updateDMSPushNotification", null);
  },
  getDmsPrePopByDealId: async function(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/dms_push/create_base_request",
      request
    );
    return response && response.data.successful ? response.data.data : null;
  },
  getDmsPrePop: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/push_to_dms/create_base_request",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },

  getCobuyerOptions: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient.ProcessRequest(
      "GET",
      "/api/push_to_dms/v2/household/" + request,
      request
    );
    return resp.data && resp.data.successful ? resp.data.data : null;
  },
  getCobuyerOptionsOld: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient.ProcessRequest(
      "GET",
      "/api/push_to_dms/v1/household/" + request,
      request
    );
    return resp.data && resp.data.successful ? resp.data.data : null;
  },
  getDetails: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/v2/details",
      request
    );
    return resp.data && resp.data.successful ? resp.data.data : null;
  },
  getDetailsByDealId: async function(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/dms_push/v2/details",
      request
    );
    return response && response.data.successful ? response.data.data : null;
  },
  getDMSLookup: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient
      .ProcessRequest("POST", "/api/push_to_dms/v2/lookup", request)
      .catch(function(error) {
        return null;
      });
    return resp && resp.data && resp.data.successful ? resp.data.data : null;
  }
};

const mutations = {
  clearPushToDmsModal(state) {
    state.PushToDmsModalInfo = {
      ShowModal: false,
      Data: null
    };
  },
  setPushToDmsModal(state, val) {
    state.PushToDmsModalInfo = val;
  },
  updateDMSPushNotification: function(state, data) {
    state.dmsPushNotification = data;
  },
  clearPushToPbsModal(state) {
    state.PushToPBSModalInfo = {
      ShowModal: false,
      TradeVehicles: [],
      ReplacementVehicles: null,
      Customer: "",
      IsGarage: false
    };
  },
  setPushToPBSModal(state, val) {
    state.PushToPBSModalInfo = val;
  },
  updateCanPushToDMS: function(state, data) {
    state.CanPushToDMS = data;
  },
  updateCanPushToDMSSingle: function(state, data) {
    state.CanPushToDMS.push(data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DMSPush/DmsPush.js